<template>
    <div class="vacancy-page">
        <div class="container">
            <div class="page-title" >
                <h1>
                    <span v-if="globalLang == ''">ВАКАНСИИ</span>
                    <span v-if="globalLang == 'kz/'">Вакансиялар</span>
                    <span v-if="globalLang == 'en/'">Vacancies</span>
                </h1>
            </div>
            <vacancyFilter></vacancyFilter>
            <div class="column-container-main">
                <div class="col-left">
                    <vacancyCards></vacancyCards>
                </div>
                <div class="col-right">
                    <vacancyContacts></vacancyContacts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store.js'
    import {mapGetters} from 'vuex'
    import vacancyFilter from '@/components/vacancy-page/vacancy-filter.vue'
    import vacancyCards from '@/components/vacancy-page/vacancy-cards.vue'
    import vacancyContacts from '@/components/vacancy-page/vacancy-contacts.vue'
    export default {
        name: 'vacancy--page',
        components: {
            vacancyFilter,
            vacancyCards,
            vacancyContacts,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        methods: {
        },
        computed: mapGetters({
            // pageSetup: 'loadHowToBy',
            // currentCityArr: 'loadCurrentCityArr',
            titleSite: 'loadSiteTitle',
        }),
        beforeRouteEnter (to, from, next) {
            if (store.state.vacancyPage != null) {
                next(vm => {
                  vm.$store.commit('removePageLoaderImg');
                  vm.$parent.$refs.topProgress.done()
                });
            } else {
                store.dispatch('getVacancyPage').then((response) => {
                    // console.log(resp, 'HOME')
                    if (response) {
                        next(vm => {
                          vm.$store.commit('removePageLoaderImg');
                          vm.$parent.$refs.topProgress.done()
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'vacancy--page';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/vacancy-page/vacancy-page.scss';
    @import '@/styles/components/vacancy-page/respond/vacancy-page-respond.scss';
    // @import '@/styles/respond/vacancy/vacancy-page-respond.scss';
</style>